import {IShape} from '../elements/question/imageMarkup';
import {ILikertScaleQuestion, ILikertScaleScale} from '../elements/question/likertScale';
import {ICalculatorFieldWithValue, ICalculatorResult} from '../elements/calculator';

export const CUSTOM_VAR_DATA_ATTRIBUTE = 'data-ncc';

export interface IRunFile {
    _id?: string;
    slideDrawLines?: ICanvasLine[][];
    elementInteractions?: Record<string, Record<string, ElementInteraction>>;
    chalkboardUserComments?: string[];
    points?: number;
    timeElapsed?: number;
    markedAnswers?: number[];
    clickedAnswers?: number[];
    correctAnswers?: number[];
    failed?: boolean;
    presentationId?: string;
    lastSlideId?: string;
    watchedSlideIds?: string[];
    requestParams?: Record<string, string>;
    roomId?: string;
    roomRunfileId?: string;
    userId?: string;
    specificIdentification?: string;
    groupIdentification?: string;
    customVars?: Record<string, unknown>;
}

export type ICanvasLine = {
    clickX: number[];
    clickY: number[];
    canvasHeight?: number;
    canvasWidth?: number;
};

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ElementInteraction {}

export interface QuestionnaireElementInteraction extends ElementInteraction {
    answered: boolean;
}

export interface QuestionElementInteractions extends QuestionnaireElementInteraction {
    clickedAnswers?: number[];
    correctAnswers?: number[];

    // used with try button
    markedAnswers?: number[];

    retriedAnswers?: {attempt: number[]}[];
    wrongAnswer?: number | undefined;

    markedAnswersIds?: string[];
    clickedAnswersIds?: string[];
}

export interface YesNoElementInteractions extends QuestionnaireElementInteraction {
    answer: number;
    answeredCorrectly: boolean;
    answerBoxColor: string;
}

export interface MarkupImageElementInteractions extends QuestionnaireElementInteraction {
    answeredCorrectly: boolean;
    correctAnswers: number[];
    answers?: IShape[];
    markedAnswers?: IShape[];
    retriedAnswers?: {attempt: {answers: IShape[]}}[];
}

export interface SequenceQuestionInteraction extends QuestionnaireElementInteraction {
    answer: string[];
    answeredSequence?: {text: string; comment: string}[];
    isWrong?: boolean;
    markedAnswers?: {text: string; comment: string}[];
    retriedAnswers?: {attempt: {text: string; comment: string}[]}[];
}

export interface QuestionMatchPairInteractions extends QuestionnaireElementInteraction {
    submittedPairs: {leftSelectedElement: string; rightSelectedElement: string}[];
    retriedAnswers?: {leftSelectedElement: string; rightSelectedElement: string}[][];
}

export interface LikertScaleInteractions extends QuestionnaireElementInteraction {
    likertScaleAnswerClicked: {
        question: ILikertScaleQuestion;
        scale: ILikertScaleScale;
    }[];
    likertScaleAnswer: {
        question: ILikertScaleQuestion;
        scale: ILikertScaleScale;
    }[];
}

export interface InputElementInteractions extends ElementInteraction {
    inputValue: string;
    answered?: boolean;
}

export interface CalculatorInteractions extends ElementInteraction {
    calculatorAnswers: ICalculatorFieldWithValue[];
    calculatorResult: ICalculatorResult;
}

export type IRetriableQuestion = MarkupImageElementInteractions | SequenceQuestionInteraction | QuestionElementInteractions;
